import { TopToolbar, usePermissions, useTranslate } from 'react-admin';
import { useTheme } from '@mui/material';
import { CustomSortButton } from '@/components/global/buttons/CustomSortButton.jsx';
import CustomCreateButton from '@/components/global/buttons/CustomCreateButton.jsx';
import { StatusFilterInput } from '@/components/global/filters/StatusFilterInput.jsx';

export const AdsCampaingsActions = () => {
    const theme = useTheme();
    const translate = useTranslate();
    const { permissions } = usePermissions();
    const canCreateAd = (permissions?.isAdmin || permissions?.isClient) && !permissions?.isPosOwner;

    return (
        <TopToolbar
            sx={{
                '& .status-form': {
                    '& .MuiFormLabel-root.MuiInputLabel-root': {
                        top: '-4px',
                    },
                },
                [theme.breakpoints.down('md')]: {
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                },
                '& .MuiButton-text.MuiButton-textPrimary': {
                    display: 'block',
                    width: 'auto',
                    minWidth: 'auto',
                    '& svg': {
                        display: 'inline-block',
                        verticalAlign: 'middle',
                    },
                },
            }}
        >
            <StatusFilterInput label={translate('common.status')} />
            <CustomSortButton
                label={translate('resources.adsCampaign.labels.sorting')}
                options={[
                    { field: 'endDate', order: 'DESC', label: translate('campaign.sorting.endDateDesc') },
                    { field: 'endDate', order: 'ASC', label: translate('campaign.sorting.endDateAsc') },
                ]}
            />
            {canCreateAd ? <CustomCreateButton label={translate('resources.adsCampaign.labels.createAdsCampaign')} size='small' /> : null}
        </TopToolbar>
    );
};
